/**
 * Phase F — Add Dynamic Table dialog.
 *
 * Empty input → backend assigns WC-{N+1} (PRD #7).
 * Hostess can also enter custom names (e.g. "Bar-1", "Table Smith").
 */
import { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { useCreateDynamicTable } from "@/hooks/useTableMutations";

export default function AddDynamicTableDialog({ open, onClose }) {
  const [name, setName] = useState("");
  const create = useCreateDynamicTable();

  const handleCancel = () => {
    setName("");
    onClose();
  };

  const handleAdd = () => {
    create.mutate(
      { name: name.trim() },
      {
        onSuccess: () => {
          setName("");
          onClose();
        },
      },
    );
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(v) => {
        if (!v) handleCancel();
      }}
    >
      <DialogContent
        data-testid="add-dynamic-dialog"
        className="w-[calc(100%-2rem)] max-w-[440px] max-h-[calc(100vh-2rem)] overflow-y-auto rounded-lg p-0 gap-0 [&>button]:hidden"
      >
        {/* Header */}
        <div className="px-5 pt-4 pb-3">
          <h2 className="text-lg font-semibold" style={{ color: "#1A1A1A" }}>
            Extra Table Name
          </h2>
        </div>
        <div style={{ borderBottom: "1px solid #E5E7EB" }} />

        {/* Body */}
        <div className="px-5 py-5">
          <Input
            data-testid="add-dynamic-input"
            autoFocus
            placeholder="Enter Table No. or Name(Default - WC)"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleAdd();
            }}
            disabled={create.isPending}
          />
        </div>

        {/* Footer */}
        <div
          className="flex justify-end gap-3 px-5 py-4 border-t"
          style={{ borderColor: "#E5E7EB" }}
        >
          <button
            data-testid="add-dynamic-cancel"
            onClick={handleCancel}
            disabled={create.isPending}
            className="px-5 py-2 rounded-md font-medium text-sm border disabled:opacity-50 transition-colors hover:bg-gray-50"
            style={{ borderColor: "#D1D5DB", color: "#374151" }}
          >
            Cancel
          </button>
          <button
            data-testid="add-dynamic-confirm"
            onClick={handleAdd}
            disabled={create.isPending}
            className="px-5 py-2 rounded-md font-semibold text-sm text-white disabled:opacity-50 transition-opacity"
            style={{ backgroundColor: "#F97316" }}
          >
            {create.isPending ? "Adding…" : "Add"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
